import { render } from "./ComparativeAnalysisChart.vue?vue&type=template&id=6bd391be&ts=true"
import script from "./ComparativeAnalysisChart.vue?vue&type=script&lang=ts"
export * from "./ComparativeAnalysisChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__